import React, { useEffect } from "react";
import { IButtonStyles, IconButton } from "@fluentui/react/lib/Button";
import { DefaultPalette } from "@fluentui/react";
import {
  IContextualMenuProps,
  IContextualMenuItem,
} from "@fluentui/react/lib/ContextualMenu";
import { IIconStyles } from "@fluentui/react";
import { colors, permissionsModules } from "constants/constants";
import { hiddenStyle } from "constants/styles";
import { useSelector } from "react-redux";
import { AppState } from "store/index";
import { eTypes } from "hoc/withCredentials";
import { IPermission } from "types/groupPermissionTypes";
import { isPermitted } from "utils/permissions/permissionsHelpers";

const iconMenuStyles: IIconStyles = {
  root: {
    color: colors.lighterBlack,
  },
};
interface IProps {
  modulePermissions: IPermission[];
  onEdit: (websiteId: number) => void;
  onDelete: (websiteId: number) => void;
  websiteId: number
}

export const WebsitesMoreActionsSubmenu: React.FunctionComponent<IProps> = ({
  modulePermissions,
  onEdit,
  onDelete,
  websiteId
}) => {
  const [menuProps, setMenuProps] = React.useState(null);
  const user = useSelector((state: AppState) => state.userProfile.userProfile);
   
  // const dispatch = useDispatch();
  const menuItems: IContextualMenuItem[] = [
    // {
    //   key: "view",
    //   name: "View",
    //   iconProps: { iconName: "RedEye", styles: iconMenuStyles },
    //   onClick: () => {},
    //   style: !isPermitted(
    //     modulePermissions,
    //     eTypes.READ,
    //     permissionsModules.Location,
    //     user.roles
    //   )
    //     ? hiddenStyle
    //     : null,
    // },
    //{
    //  key: "setStatus", //with submenu
    //  name: "Set Status",
    //  iconProps: { iconName: "LocationCircle", styles: iconMenuStyles },
    //  style: !isPermitted(
    //    modulePermissions,
    //    eTypes.UPDATE,
    //    permissionsModules.Location,
    //    user.roles
    //  )
    //    ? hiddenStyle
    //    : null,
    //  onClick: () => {},
    //  subMenuProps: {
    //    items: [
    //      {
    //        key: "active",
    //        text: "Active",
    //        onClick: () => onSetStatus(true),
    //      },
    //      {
    //        key: "inActive",
    //        text: "inactive",
    //        onClick: () => onSetStatus(false),
    //      },
    //    ],
    //  },
    //},
    // {
    //   key: "saveAsPDF", //with submenu
    //   name: "Save as PDF",
    //   iconProps: { iconName: "PDF", styles: iconMenuStyles },
    //   onClick: () => {},
    // },
    {
        key: "edit", //with submenu
          name: "Edit",
        iconProps: { iconName: "Edit", styles: iconMenuStyles },
        onClick: () => onEdit(websiteId),
        style: !isPermitted(
            modulePermissions,
            eTypes.UPDATE,
            permissionsModules.Location,
            user.roles
        )
            ? hiddenStyle
            : null,
    },
    {
      key: "delete", //with submenu
        name: "Delete",
      iconProps: { iconName: "Delete", styles: iconMenuStyles },
      onClick: () => onDelete(websiteId),
      style: !isPermitted(
        modulePermissions,
        eTypes.DELETE,
        permissionsModules.Location,
        user.roles
      )
        ? hiddenStyle
        : null,
    },
  ];

  useEffect(() => {
    const menuProps: IContextualMenuProps = {
      shouldFocusOnMount: true,
      items: menuItems,
    };

    setMenuProps(menuProps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteId]);

  return (
    <IconButton
      className="iconButton"
      iconProps={{
        iconName: "Settings",
      }}
      styles={buttonStyles}
      text="Group Action"
      menuProps={menuProps}
    />
  );
};

const buttonStyles: IButtonStyles = {
  root: {
    width: "auto",
    color: DefaultPalette.themePrimary,
    borderColor: DefaultPalette.themePrimary,
  },
  rootHovered: {
    borderColor: DefaultPalette.themePrimary,
    color: DefaultPalette.themePrimary,
  },
};
